import axios from 'axios'
import { getCredentials } from './general'

export const validateMember = async (
  membermail,
  setLoading,
  setFieldValue,
  setIsMember,
  setAlertMessage,
  memberValidationEndpoint,
  clientName
) => {
  const url = `${memberValidationEndpoint}?client=${clientName}&id=${membermail}`

  let getRequest = {
    method: 'get',
    url,
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
      ...(memberValidationEndpoint?.includes('cst-apps')
        ? { Authorization: getCredentials() }
        : {}),
    },
  }

  try {
    if (!memberValidationEndpoint) {
      throw new Error('Invalid information to validate')
    }
    setLoading(true)
    const response = await axios(getRequest)
    const memberFound = response.data
    if (response.status === 200) {
      if (memberFound) {
        memberFound?.firstName &&
          setFieldValue('contactName', memberFound?.firstName)
        setFieldValue('contactLastName', `${memberFound?.lastName || ''}`)
        setFieldValue('contactEmail', `${membermail}`)
        setIsMember(memberFound)
        setAlertMessage(
          `Welcome ${memberFound?.firstName || ''} ${
            memberFound?.lastName || ''
          }`
        )
      }
    } else {
      setFieldValue('memberEmail', '')
      setIsMember(false)
      setAlertMessage(`Invalid member email`)
    }
  } catch (error) {
    console.log(error.message)
    setFieldValue('memberEmail', '')
    setIsMember(false)
    setAlertMessage(`Invalid member email`)
  } finally {
    setLoading(false)
  }
}

export function validEmail(value) {
  if (value) {
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
      return false
    }
  } else {
    return false
  }
  return true
}
